import apiClient from "@/api/client";
import type {
  OrderSimulation,
  OrderSimulationInput,
  SimulationResult,
} from "@/features/finances/types/simulation";

export const simulationsApi = {
  list: () =>
    apiClient
      .get<{ data: OrderSimulation[] }>("/finances/order-simulations/")
      .then((r) => r.data.data),

  get: (id: string) =>
    apiClient
      .get<{ data: OrderSimulation }>(`/finances/order-simulations/${id}/`)
      .then((r) => r.data.data),

  create: (payload: OrderSimulationInput) =>
    apiClient
      .post<{ data: OrderSimulation }>("/finances/order-simulations/", payload)
      .then((r) => r.data.data),

  update: (id: string, payload: OrderSimulationInput) =>
    apiClient
      .patch<{ data: OrderSimulation }>(`/finances/order-simulations/${id}/`, payload)
      .then((r) => r.data.data),

  remove: (id: string) =>
    apiClient.delete(`/finances/order-simulations/${id}/`).then(() => undefined),

  compute: (id: string) =>
    apiClient
      .get<{ data: SimulationResult }>(`/finances/order-simulations/${id}/compute/`)
      .then((r) => r.data.data),

  // live podgląd z draftu — bez zapisu
  preview: (payload: OrderSimulationInput) =>
    apiClient
      .post<{ data: SimulationResult }>("/finances/order-simulations/preview/", payload)
      .then((r) => r.data.data),
};
